'use strict';

angular.module('theme').component('compSignup', {
	templateUrl: 'component/comp-signup.html',
	controller: function ($rootScope, CustomerService, Toast, $cookies) {
		var self = this;
		self.gdprAccepted = false;

		var paramString = window.location.search;
		var urlParams = new URLSearchParams(paramString);

		if ($cookies.get('campaign-code-discount')) {
			var discount = JSON.parse($cookies.get('campaign-code-discount'));

			self.discountCode = discount.code;

			if (!discount || discount.code === '') return;

			if (discount.type === 'Percent') {
				self.percentDiscount = Math.abs(discount.value) / 100;
			} else if(discount.amount) {
				var value = Math.abs(discount.amount);

				if (value == 0) return;

				self.discount = value;
			}
		}

		this.compRegister = function (email) {
			self.errorMsg = '';
			self.saving = true;
			var howDidYouFindUs = urlParams.get('event') || '';

			CustomerService.compRegister(email, howDidYouFindUs).then(function () {
				self.saving = false;

				Toast.successContent('<i class="mk-icon mk-icon-share mk-icon-x5"></i><h2 class="mt-md">Du är registrerad!</h2>');
			}, function (errorResponse) {
				self.errorMsg = errorResponse.data.message;
			});
		};
	}
});
